import React, { useEffect, useMemo, useState } from 'react'
import "./Hotel.css"
import defaultImage from "../../assets/images/default.png"
import { useTranslation } from '../../contexts/TranslationContext'

const HOTEL_IMAGE_BASE_URL = "https://alltimetest7.inter-netsys.com";

const normalizeImageValue = (value) => {
    if (!value) return "";

    if (typeof value === "string") {
        return value.trim();
    }

    if (typeof value === "object") {
        return (
            value.image ||
            value.url ||
            value.src ||
            value.file_url ||
            value.fileUrl ||
            value.path ||
            ""
        ).toString().trim();
    }

    return "";
};

const toAbsoluteImageUrl = (src) => {
    const normalizedSrc = normalizeImageValue(src);

    if (!normalizedSrc) return "";
    if (/^(data:|blob:|https?:)/i.test(normalizedSrc)) return normalizedSrc;
    if (normalizedSrc.startsWith("//")) return `https:${normalizedSrc}`;

    try {
        return new URL(
            normalizedSrc.startsWith("/") ? normalizedSrc : `/${normalizedSrc}`,
            HOTEL_IMAGE_BASE_URL
        ).toString();
    } catch {
        return normalizedSrc;
    }
};

const normalizeImages = (imagesValue) => {
    if (!imagesValue) return [];

    if (Array.isArray(imagesValue)) {
        return imagesValue
            .flat(Infinity)
            .map(toAbsoluteImageUrl)
            .filter(Boolean);
    }

    if (typeof imagesValue === "string") {
        return imagesValue
            .split(",")
            .map(toAbsoluteImageUrl)
            .filter(Boolean);
    }

    const singleImage = toAbsoluteImageUrl(imagesValue);
    return singleImage ? [singleImage] : [];
};

const Hotel = ({ image, title, location, desc, price, sale, reviews, rate, date,
    Images, HotelCode, Currency, Rooms, HotelInfo
    , onClick, onRemove, onSelect }) => {

  const { t } = useTranslation();
  const [imgError, setImgError] = useState(false);

    const resolvedImage = useMemo(() => {
        const imageCandidates = [
            image,
            Images,
            HotelInfo?.Images,
            HotelInfo?.Image,
            HotelInfo?.HotelPicture,
            HotelInfo?.image,
        ].flatMap((candidate) => normalizeImages(candidate));

        return imageCandidates.find(Boolean) || defaultImage;
    }, [image, Images, HotelInfo]);

    useEffect(() => {
        setImgError(false);
    }, [resolvedImage]);

    const truncateHTML = (html, maxLength) => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        const text = tempDiv.textContent || tempDiv.innerText || '';
        const truncatedText = text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
        return truncatedText;
    };
  return ( 
    <div className='hotel-card' onClick={onSelect}>
        {/* {
            onRemove ? (
                <div className='hotel-add-btn remove' onClick={onRemove}>
                   <svg xmlns="http://www.w3.org/2000/svg" width="17" height="19" viewBox="0 0 17 19" fill="none">
                        <path d="M1 4.77778H16M6.625 8.55556V14.2222M10.375 8.55556V14.2222M1.9375 4.77778L2.875 16.1111C2.875 16.6121 3.07254 17.0925 3.42417 17.4468C3.77581 17.801 4.25272 18 4.75 18H12.25C12.7473 18 13.2242 17.801 13.5758 17.4468C13.9275 17.0925 14.125 16.6121 14.125 16.1111L15.0625 4.77778M5.6875 4.77778V1.94444C5.6875 1.69396 5.78627 1.45374 5.96209 1.27662C6.1379 1.0995 6.37636 1 6.625 1H10.375C10.6236 1 10.8621 1.0995 11.0379 1.27662C11.2137 1.45374 11.3125 1.69396 11.3125 1.94444V4.77778" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            ) : (
                <div className='hotel-add-btn' onClick={onSelect}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.75 9.75V15C9.75 15.1989 9.67098 15.3897 9.53033 15.5303C9.38968 15.671 9.19891 15.75 9 15.75C8.80109 15.75 8.61032 15.671 8.46967 15.5303C8.32902 15.3897 8.25 15.1989 8.25 15V9.75H3C2.80109 9.75 2.61032 9.67098 2.46967 9.53033C2.32902 9.38968 2.25 9.19891 2.25 9C2.25 8.80109 2.32902 8.61032 2.46967 8.46967C2.61032 8.32902 2.80109 8.25 3 8.25H8.25V3C8.25 2.80109 8.32902 2.61032 8.46967 2.46967C8.61032 2.32902 8.80109 2.25 9 2.25C9.19891 2.25 9.38968 2.32902 9.53033 2.46967C9.67098 2.61032 9.75 2.80109 9.75 3V8.25H15C15.1989 8.25 15.3897 8.32902 15.5303 8.46967C15.671 8.61032 15.75 8.80109 15.75 9C15.75 9.19891 15.671 9.38968 15.5303 9.53033C15.3897 9.67098 15.1989 9.75 15 9.75H9.75Z" fill="white"/>
                    </svg>
                </div>
            )
        } */}
        <div className="hotel-card-image">
            {/* <div className='hotel-card-image-btn'> */}
                {/* <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 16 15" fill="none">
                    <path d="M8.08 12.7112L8 12.7929L7.912 12.7112C4.112 9.18801 1.6 6.85831 1.6 4.49591C1.6 2.86104 2.8 1.63488 4.4 1.63488C5.632 1.63488 6.832 2.45232 7.256 3.56403H8.744C9.168 2.45232 10.368 1.63488 11.6 1.63488C13.2 1.63488 14.4 2.86104 14.4 4.49591C14.4 6.85831 11.888 9.18801 8.08 12.7112ZM11.6 0C10.208 0 8.872 0.662125 8 1.70027C7.128 0.662125 5.792 0 4.4 0C1.936 0 0 1.97003 0 4.49591C0 7.57766 2.72 10.1035 6.84 13.921L8 15L9.16 13.921C13.28 10.1035 16 7.57766 16 4.49591C16 1.97003 14.064 0 11.6 0Z" fill="#254AA5"/>
                </svg> */}
            {/* </div> */}
            <img
                src={imgError ? defaultImage : resolvedImage}
                onError={() => setImgError(true)}
            />
        </div>
        <div className='hotel-card-content'>
            <div className='hotel-card-title'>{HotelInfo?.HotelName}</div>
            <div className='hotel-card-location'>{HotelInfo?.Address}</div>
            <div className='hotel-card-specs'>
                {/* <div className='hotel-card-spec'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                        <path d="M0 13V11.5556C0.411667 11.5556 0.720417 11.4352 0.92625 11.1944C1.13208 10.9537 1.53833 10.8333 2.145 10.8333C2.75167 10.8333 3.16875 10.9537 3.39625 11.1944C3.62375 11.4352 3.9325 11.5556 4.3225 11.5556C4.7125 11.5556 5.02125 11.4352 5.24875 11.1944C5.47625 10.9537 5.89333 10.8333 6.5 10.8333C7.10667 10.8333 7.52375 10.9537 7.75125 11.1944C7.97875 11.4352 8.2875 11.5556 8.6775 11.5556C9.0675 11.5556 9.37625 11.4352 9.60375 11.1944C9.83125 10.9537 10.2483 10.8333 10.855 10.8333C11.4617 10.8333 11.8679 10.9537 12.0738 11.1944C12.2796 11.4352 12.5883 11.5556 13 11.5556V13C12.3608 13 11.9411 12.8796 11.7409 12.6389C11.5407 12.3981 11.2454 12.2778 10.855 12.2778C10.4646 12.2778 10.1558 12.3981 9.92875 12.6389C9.70168 12.8796 9.2846 13 8.6775 13C8.0704 13 7.65332 12.8796 7.42625 12.6389C7.19918 12.3981 6.89043 12.2778 6.5 12.2778C6.10957 12.2778 5.80082 12.3981 5.57375 12.6389C5.34668 12.8796 4.9296 13 4.3225 13C3.7154 13 3.29832 12.8796 3.07125 12.6389C2.84418 12.3981 2.53543 12.2778 2.145 12.2778C1.75457 12.2778 1.45925 12.3981 1.25905 12.6389C1.05885 12.8796 0.639167 13 0 13ZM0 9.75V8.30556C0.411667 8.30556 0.720417 8.18519 0.92625 7.94444C1.13208 7.7037 1.53833 7.58333 2.145 7.58333C2.75167 7.58333 3.17157 7.7037 3.4047 7.94444C3.63783 8.18519 3.94377 8.30556 4.3225 8.30556C4.7125 8.30556 5.02125 8.18519 5.24875 7.94444C5.47625 7.7037 5.89333 7.58333 6.5 7.58333C7.10667 7.58333 7.52375 7.7037 7.75125 7.94444C7.97875 8.18519 8.2875 8.30556 8.6775 8.30556C9.0675 8.30556 9.37625 8.18519 9.60375 7.94444C9.83125 7.7037 10.2483 7.58333 10.855 7.58333C11.4617 7.58333 11.8679 7.7037 12.0738 7.94444C12.2796 8.18519 12.5883 8.30556 13 8.30556V9.75C12.3608 9.75 11.9411 9.62963 11.7409 9.38889C11.5407 9.14815 11.2454 9.02778 10.855 9.02778C10.4646 9.02778 10.1638 9.14815 9.9528 9.38889C9.74177 9.62963 9.31667 9.75 8.6775 9.75C8.06 9.75 7.64032 9.62963 7.41845 9.38889C7.19658 9.14815 6.89043 9.02778 6.5 9.02778C6.08833 9.02778 5.7824 9.14815 5.5822 9.38889C5.382 9.62963 4.9621 9.75 4.3225 9.75C3.6829 9.75 3.25758 9.62963 3.04655 9.38889C2.83552 9.14815 2.535 9.02778 2.145 9.02778C1.755 9.02778 1.4599 9.14815 1.2597 9.38889C1.0595 9.62963 0.6396 9.75 0 9.75ZM3.185 6.06667L5.34625 3.66528L4.69625 2.94306C4.33875 2.54583 3.95958 2.25695 3.55875 2.07639C3.15792 1.89583 2.665 1.80556 2.08 1.80556V9.77297e-07C2.8925 9.77297e-07 3.56417 0.099427 4.095 0.298279C4.62583 0.497131 5.14583 0.879186 5.655 1.44445L9.815 6.06667C9.63083 6.19907 9.45208 6.30452 9.27875 6.383C9.10542 6.46148 8.905 6.50048 8.6775 6.5C8.2875 6.5 7.97875 6.37963 7.75125 6.13889C7.52375 5.89815 7.10667 5.77778 6.5 5.77778C5.89333 5.77778 5.47625 5.89815 5.24875 6.13889C5.02125 6.37963 4.7125 6.5 4.3225 6.5C4.095 6.5 3.89458 6.461 3.72125 6.383C3.54792 6.305 3.36917 6.19956 3.185 6.06667ZM9.555 9.77297e-07C10.01 9.77297e-07 10.3946 0.177668 10.7087 0.533001C11.0229 0.888334 11.18 1.31252 11.18 1.80556C11.18 2.31111 11.0229 2.73843 10.7087 3.0875C10.3946 3.43657 10.01 3.61111 9.555 3.61111C9.1 3.61111 8.71542 3.43657 8.40125 3.0875C8.08708 2.73843 7.93 2.31111 7.93 1.80556C7.93 1.31204 8.08708 0.887612 8.40125 0.532279C8.71542 0.176945 9.1 -0.000480504 9.555 9.77297e-07Z" fill="#494949"/>
                    </svg>
                    <div>Pool</div>
                </div>
                <div className='hotel-card-spec'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
                        <path d="M9.33333 4.55556H8.83333V5.05556V7.22222C8.83333 8.58063 7.82693 9.61111 6.66667 9.61111H2.66667C1.5064 9.61111 0.5 8.58063 0.5 7.22222V0.5H10.6667C11.0936 0.5 11.5 0.880484 11.5 1.44444V3.61111C11.5 3.87393 11.4033 4.11873 11.2421 4.29335C11.0821 4.46661 10.8742 4.55556 10.6667 4.55556H9.33333ZM10.6667 4.11111H11.1667V3.61111V1.44444V0.944444H10.6667H9.33333H8.83333V1.44444V3.61111V4.11111H9.33333H10.6667ZM0.5 12.0556H10.1667V12.5H0.5V12.0556Z" fill="white" stroke="#494949"/>
                    </svg>
                    <div>Breakfast</div>
                </div> */}
            </div>
            {
                HotelInfo?.Description && (
                    <div className='hotel-card-text'>
                        <span>{t("Description")}</span>
                        <div>
                            {truncateHTML(HotelInfo?.Description, 100)}
                        </div>
                    </div>
                )
            }
           
        </div>
        <div className='hotel-card-price'>
            <div className='hard-card-info'>
                <div>
                    <div className='hotel-card-price-title'>
                        <div></div>
                        <span>{sale}</span>
                    </div>
                    <div className="hotel-card-price-para">
                        {/* includes taxes & fees */}
                    </div>
                </div>
           
                <div>
                    {
                        rate && (
                            <div className='hotel-card-rate-container'>
                                <div className='hotel-card-rate'>{rate}</div>
                                <div className='hotel-card-reviews'>
                                    <div>{t("Rating")}</div>
                                    {/* <span>{reviews} reviews</span> */}
                                </div>
                            </div>
                        )
                    }
                    
                </div>
            </div >
               
                {/* <div className='hotel-card-desc'>
                </div>
                <div className='hotel-card-dates'>
                <div className='hotel-card-date'>
                   {t("CheckIn")}: {HotelInfo.CheckInTime}
                </div>
                <div className='hotel-card-date'>
                {t("Checkout")}: {HotelInfo.CheckOutTime}
                </div>
                </div> */}
            
        </div>
    </div>
  )
}

export default Hotel
